export default __webpack_public_path__ + "static/logto-blog-2fd3ff02dd2e3c558efaae5fcaa3049c.png";